import { CoinTypography } from "Infrastructure/Components/CoinTypography";
import { useLocale } from "Infrastructure/Hooks/useLocale";
import { Box, useTheme } from "@mui/material";
import type { FC } from "react";

interface CoinCellProps {
  value: number;
  suffix: string;
}

export const CoinCell: FC<CoinCellProps> = ({ value, suffix }) => {
  const locale = useLocale();
  const formattedValue = value.toLocaleString(locale);
  const { customFontWeight } = useTheme();

  return (
    <Box textAlign="right">
      <CoinTypography variant="body2" fontWeight={customFontWeight.bold}>
        {formattedValue} {suffix}
      </CoinTypography>
    </Box>
  );
};
